import request from '@/utils/request'

export function product_cate(data) {
    return request({ url: 'product_cate_list', data });
}

export function product_list(data) {
    return request({ url: 'product_list', data });
}

export function product_detail(data) {
    return request({ url: 'product_detail', data });
}